import React, { useEffect, useState } from 'react';
import "./Category.css";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import { useJwt } from "react-jwt";
import { GetFeedbackPage, Getblinkit } from '../apiconfig/authService';
import { Pagination } from "rsuite";
import 'rsuite/dist/rsuite.min.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { api_url } from '../apiconfig/authService';
import { RiLoaderFill } from "react-icons/ri";

function Flipkart(props) {
    const navigate = useNavigate();
    const { decodedToken, isExpired } = useJwt(localStorage.getItem('accessToken'));
    if (isExpired)
        navigate('/');

    const message = props.message;
    const today = new Date();
    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);
    const [feedbacksData, setFeedbacksData] = useState([]);
    const [totalFeedbacks, setTotalFeedbacks] = useState();
    const [pincode, setPincode] = useState([]);
    const [Selectpincode, setSelectpincode] = useState("122001");
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [totalCategories, setTotalCategories] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(25);
    const [recordIdToDelete, setRecordIdToDelete] = useState('');
    const [refetchData, setRefetchData] = useState(false);
    const [selectedRows, setSelectedRows] = useState({});
    const [selectAll, setSelectAll] = useState(false);
    const [selectedData, setSelectedData] = useState({});
    const [loading, setLoading] = useState(false);

    const handlePerPageRecordsChange = (e) => {
      const value = e.target.value;
      if (value === "all") {
        setItemsPerPage("all");
      } else {
        setItemsPerPage(Number(value));
      }
      setPage(1);
    };

    const formatUTCDate = (utcDateString) => {
      const date = new Date(utcDateString);

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // convert 0 → 12, 13 → 1, etc.
      hours = String(hours).padStart(2, "0");

      return `${day}-${month}-${year} at ${hours}:${minutes}:${seconds} ${ampm}`;
    };


    useEffect(() => {
        (
            async () => {
                setLoading(true);
                try {
                    const queryParams = {
                        pincode: Selectpincode,
                        page,
                        itemsPerPage,
                        search,
                        startDate: startDate ? startDate.toISOString().split('T')[0] : null,
                        endDate: endDate ? endDate.toISOString().split('T')[0] : null,
                    };

                    // const feedbacksData = await Getblinkit(queryParams, localStorage.getItem('accessToken'));
                    const feedbacksData = await axios.get(
                        `${api_url}/store/getflipkart`,
                        { params: queryParams }
                    );
                    setLoading(false);
                    setFeedbacksData(feedbacksData.data.items);
                    // console.log("eedbacksData.data.items??????", feedbacksData.data.items)
                    // console.log("eedbacksData.data.items??????", feedbacksData.data.items)
                    setPincode(feedbacksData?.data?.items?.pincodeinfo)
                    setPageCount(Math.ceil(feedbacksData?.data?.pagination?.pageCount));
                    setTotalFeedbacks(feedbacksData?.data?.pagination?.count);
                } catch (error) {
                    console.log(error);
                }
            }
        )();
    }, [page, itemsPerPage, refetchData, Selectpincode, search, startDate, endDate]);

    const handleViewFeedbackClick = (feedbackid) => {
        navigate(`/viewFeedback/${feedbackid}`);
    };


    const handlePrevious = () => {
        setPage((p) => {
            if (p === 1) return p;
            return p - 1;
        });
    };
    const handleNext = () => {
        setPage((p) => {
            if (p === pageCount) return p;
            return p + 1;
        });
    };

    const handleSearchBoxSubmit = (event) => {
        event.preventDefault();
        setPage(1);
        setRefetchData(!refetchData)
    };
    const handleSelectAll = () => {
        const allSelected = !selectAll; // Toggle the selectAll state
        setSelectAll(allSelected);

        const updatedSelectedRows = {};
        const updatedSelectedData = {};

        if (allSelected) {
            // Select all rows
            feedbacksData.forEach((item) => {
                updatedSelectedRows[item._id] = true;
                updatedSelectedData[item._id] = {
                    productId: item.productid,
                    flipkartid: item.flipkartid,
                };
            });
        }

        setSelectedRows(updatedSelectedRows);
        setSelectedData(updatedSelectedData);

    };
    const handleRowSelect = (id, productId, flipkartid) => {
        const updatedSelectedRows = { ...selectedRows, [id]: !selectedRows[id] };

        setSelectedRows(updatedSelectedRows);

        // Update the list of selected product and Zepto IDs
        const updatedSelectedData = { ...selectedData };
        if (updatedSelectedRows[id]) {
            updatedSelectedData[id] = { productId, flipkartid };
        } else {
            delete updatedSelectedData[id];
        }

        setSelectedData(updatedSelectedData);

        // Optionally update a "Select All" state
        const allSelected = feedbacksData.every((item) => updatedSelectedRows[item._id]);
        setSelectAll(allSelected);
    };
    const handleUpload = async (productId, flipkartid) => {

        const selectedEntries = Object.values(selectedData);
        if (selectedEntries.length === 0) {
            toast.warning("Please select at least one row before uploading.", {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            return;
        }

        const pincode = "122002"; // Replace with the desired pincode
        const payload = {
            products: [
                { productId, flipkartid }
            ]
        };
        if (payload === "") {
            toast.error(`🚨 No product selected! Please choose a Product ID to proceed.`, {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }

        fetch(`${api_url}/manual/getProductsFlipkartManual?pincode=${pincode}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ products: Object.values(selectedData) }),
        })
            .then((response) => response.json())
            .then((data) => {
                toast.success("Manual scrapping initiated successfully!", {
                    position: "top-right",
                    autoClose: 1000,
                });
            })
            .catch((error) => {
                toast.error("Failed to initiate manual scrapping!", {
                    position: "top-right",
                    autoClose: 1000,
                });
            });

    }

    return (
      <div className="dashboard-content">
        <Sidebar />
        <div className="body-cart tab-content dasContent p-4 bg-white rounded">
          <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
            <h1 className="heading h4 mb-0 fw-bold">
              Flipkart Management
              <br />
              <small className="text-primary h6 fw-bold">
                {!loading && totalFeedbacks !== 0
                  ? `Total counts ${totalFeedbacks}`
                  : "\u00A0"}
              </small>
            </h1>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleUpload}
            >
              Manual Scrapping
            </button>
          </div>
          <div className="collapse mb-4" id="filter">
            <div className="card card-body">
              <form className="filterForm" action="/">
                <div className="row">
                  <div className="col-lg-12 mb-2">
                    <h4 className="text-primary h6 fw-bold">Filter Things</h4>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4 mb-2">
                    <div className="form-floating">
                      <select
                        className="form-select"
                        id="floatBilling"
                        aria-label="Billing"
                      >
                        <option defaultValue>Select</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </select>
                      <label htmlFor="floatBilling">Billing</label>
                    </div>
                  </div>
                  <div className="col-lg-4 mb-2">
                    <div className="form-floating">
                      <select
                        className="form-select"
                        id="floatStatus"
                        aria-label="Status"
                      >
                        <option defaultValue>Select</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </select>
                      <label htmlFor="floatStatus">Status</label>
                    </div>
                  </div>
                  <div className="col-lg-4 mb-2">
                    <button
                      type="submit"
                      className="btn btn-primary btn-lg save-btn text-uppercase w-100"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="searchList row g-3 align-items-end">
            {/* Display Records Section */}
            <div className="col-lg-2 col-md-3 col-sm-4">
              <label className="form-label">Display Records</label>
              <select
                className="form-select"
                value={itemsPerPage}
                onChange={handlePerPageRecordsChange}
              >
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="500">500</option>
                <option value="1000">1000</option>
              </select>
            </div>

            {/* Pincode Dropdown */}

            <div className="col-lg-2 col-md-3 col-sm-4 h-50">
              <label className="form-label">Select Pincode</label>
              <select
                className="form-select"
                value={Selectpincode}
                onChange={(e) => setSelectpincode(e.target.value)}
              >
                <option value="122002">122002</option>
                <option value="122001">122001</option>
              </select>
            </div>

            {/* Date Filters */}
            <div className="col-lg-4 col-md-6 col-sm-8">
              <form onSubmit={handleSearchBoxSubmit}>
                <div className="row">
                  <div className="col">
                    <label className="form-label">Start Date</label>
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                      placeholderText="Select start"
                    />
                  </div>
                  <div className="col">
                    <label className="form-label">End Date</label>
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                      placeholderText="Select end"
                    />
                  </div>
                  <div className="col-auto d-flex align-items-end">
                    <button type="submit" className="btn btn-primary">
                      Filter
                    </button>
                  </div>
                </div>
              </form>
            </div>

            {/* Search Box */}
            <div className="col-lg-2 col-md-3 col-sm-4 text-end">
              <form className="sForm w-100" onSubmit={handleSearchBoxSubmit}>
                <input
                  type="text"
                  onChange={(event) => setSearch(event.target.value)}
                  className="form-control form-control-md"
                  placeholder="Search"
                />
              </form>
            </div>
          </div>

          {loading ? (
            <div className="d-flex align-items-center justify-content-center">
              <RiLoaderFill
                size={40}
                className="text-success spin-animation text-center"
              />
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-borderless table-hover my-3">
                <thead>
                  <tr>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "50px",
                      }}
                      scope="col"
                      width="45"
                      align="center"
                    >
                      <div className="selectAll">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={selectAll}
                          onChange={handleSelectAll}
                          aria-label="Select all rows"
                        />
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "20px",
                      }}
                      scope="col"
                      width="80"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">SR.</span>
                        <button className="filtBtn idFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "100px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Product ID</span>
                        <button className="filtBtn fNameFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "100px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Product Name</span>
                        <button className="filtBtn fNameFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "150px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Flipkart Url</span>
                        <button className="filtBtn lNameFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "100px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Code</span>
                        <button className="filtBtn lNameFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "200px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Message</span>
                        <button className="filtBtn lNameFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "120px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Pincode</span>
                        <button className="filtBtn lNameFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "200px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Flipkart Price</span>
                        <button className="filtBtn lNameFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "200px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Flipkart Quantity</span>
                        <button className="filtBtn lNameFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "150px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Availiblity</span>
                        <button className="filtBtn lNameFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "50px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">IsScrape</span>
                        <button className="filtBtn lNameFilter"></button>
                      </div>
                    </th>

                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "170px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Created Date</span>
                        <button className="filtBtn statusFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "170px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Modified Date</span>
                        <button className="filtBtn emailFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "150px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Scrape</span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className="table-group-divider">
                  {feedbacksData.length > 0 &&
                    feedbacksData?.map((item, index) => (
                      <tr key={item?._id}>
                        <td>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={!!selectedRows[item?._id]}
                            onChange={() =>
                              handleRowSelect(
                                item?._id,
                                item?.productid,
                                item?.flipkartid
                              )
                            }
                            aria-label={`Select row for product ${item?.productid}`}
                          />
                        </td>
                        <td>{index + 1}</td>
                        <td>{item?.productid}</td>
                        <td>{item?.productname}</td>
                        <td>{item?.flipkartid?.substring(0, 40)}...</td>
                        {item.pincodeinfo.map((pincodeItem, pIndex) => (
                          <React.Fragment key={pIndex}>
                            <td>{pincodeItem?.code}</td>
                            <td>{pincodeItem?.message}</td>
                            <td>{pincodeItem?.pincode}</td>
                            <td>{pincodeItem?.flipkartprice}</td>
                            <td>{pincodeItem?.flipkartquantity}</td>
                            <td>{pincodeItem?.availiblity}</td>
                            <td>{pincodeItem?.isScrape ? "true" : "false"}</td>
                          </React.Fragment>
                        ))}
                        <td>{formatUTCDate(item?.createddate)}</td>
                        <td>{formatUTCDate(item?.modifieddate)}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-primary"
                            onClick={() =>
                              handleUpload(item?.productid, item?.flipkartid)
                            }
                          >
                            Manual
                          </button>
                        </td>
                      </tr>
                    ))}
                  {feedbacksData?.length === 0 && (
                    <tr>
                      <td colSpan="15" className="py-5">
                        <div
                          style={{
                            display: "flex",
                            marginLeft: "400px",
                            alignItems: "center",
                            height: "100%",
                          }}
                        >
                          <strong>
                            Products are not available for selected filters
                          </strong>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          {loading ||
          itemsPerPage === "all" ||
          feedbacksData?.length === 0 ? null : (
            <div className="resultList pt-3 border-top">
              <div className="row">
                <div className="d-flex justify-content-between displayRecord col mt-2">
                  {totalFeedbacks === 0 ? (
                    <div style={{ margin: "auto" }}>No Data found.</div>
                  ) : (
                    <div>
                      Showing {(page - 1) * itemsPerPage + 1} -{" "}
                      {totalFeedbacks < itemsPerPage * page
                        ? totalFeedbacks
                        : itemsPerPage * page}{" "}
                      of {totalFeedbacks} entries.
                    </div>
                  )}
                  {/* Render pagination only if totalFeedbacks is greater than 0 */}
                  {totalFeedbacks > 0 && (
                    <div>
                      <Pagination
                        prev
                        last
                        next
                        first
                        size="sm"
                        ellipsis
                        boundaryLinks
                        onSelect={setPage}
                        limit={Number(itemsPerPage)}
                        onChangeLimit={setItemsPerPage}
                        layout={["pager", "skip"]}
                        pages={pageCount}
                        total={totalFeedbacks}
                        maxButtons={5}
                        activePage={page}
                        onChangePage={(page) => {
                          setPage(page);
                        }}
                      />
                    </div>
                  )}
                  {/* Pagination End */}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
}
export default Flipkart;
